import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { LabeledSelect } from 'components/Blocks';

import { sortByName } from 'utils/array';
import { OutsourceProvider, loaders } from 'entities';

interface Props {
  value: string;
  onChange: (provider: OutsourceProvider) => void;
}

export function OutsourceProviderSelect({ value, onChange }: Props): JSX.Element {
  const { t } = useLang();

  const { data: clients, loading } = loaders.outsourceProviders.listOutsourceProviders.use({
    defaultValue: [],

    parser: sortByName,
  });

  const handleChange = useCallback(
    (id: string) => {
      onChange(clients.find((provider) => provider.id === id) as OutsourceProvider);
    },
    [clients, onChange],
  );

  return (
    <LabeledSelect
      id="outsourceProvider"
      options={clients}
      value={value}
      onChangeDirect={handleChange}
      label={t('outsource-provider') || ''}
      loading={loading}
      isSearchable
      labelKey="name"
    />
  );
}
